import {Utilities} from '@shared/utilities/utilities.model';

export class MechanicWorkingItemsModel {
    coupon: boolean;
    panelLightOn: boolean;
    controlUnitSoftwareUpdate: boolean;
    navigatorSoftwareUpdate: boolean;
    brakingControl: boolean;
    frontPadReplacement: boolean;
    rearPadReplacement: boolean;
    frontDiscReplacement: boolean;
    rearDiscReplacement: boolean;
    frontWipersReplacement: boolean;
    rearWipersReplacement: boolean;
    completeEngineDistribution: boolean;
    gearboxControl: boolean;
    clutchControl: boolean;
    noisyLimber: boolean;
    frontShockAbsorber: boolean;
    noisyRear: boolean;
    rearShockAbsorber: boolean;
    electricalSystemCheck: boolean;
    alternatorCheck: boolean;
    battery: boolean;
    fastBatteryCharge: boolean;
    interiorLight: boolean;
    signalLight: boolean;
    projectorLight: boolean;
    fluidLevelCheck: boolean;
    ACPlantControl: boolean;
    ACFilterReplacement: boolean;
    ACFilterSterilization: boolean;
    revision: boolean;
    gasPlantMaintenance: boolean;
    gasCylindersRevision: boolean;
    engine: boolean;
    steering: boolean;
    suspensions: boolean;
    exhaustFiring: boolean;
    gearTransmission: boolean;
    brakeSystem: boolean;
    internalParts: boolean;
    saddlery: boolean;
    safetyDevices: boolean;
    airConditioning: boolean;
    wiring: boolean;
    aerialPlatformsMaintenance: boolean;
    hydraulicSideMaintenance: boolean;
    refrigeratedMaintenance: boolean;
    craneRevision: boolean;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.coupon = model.coupon;
            this.panelLightOn = model.panel_light_on;
            this.controlUnitSoftwareUpdate = model.control_unit_software_update;
            this.navigatorSoftwareUpdate = model.navigator_software_update;
            this.brakingControl = model.braking_control;
            this.frontPadReplacement = model.front_pad_replacement;
            this.rearPadReplacement = model.rear_pad_replacement;
            this.frontDiscReplacement = model.front_disc_replacement;
            this.rearDiscReplacement = model.rear_disc_replacement;
            this.frontWipersReplacement = model.front_wipers_replacement;
            this.rearWipersReplacement = model.rear_wipers_replacement;
            this.completeEngineDistribution = model.complete_engine_distribution;
            this.gearboxControl = model.gearbox_control;
            this.clutchControl = model.clutch_control;
            this.noisyLimber = model.noisy_limber;
            this.frontShockAbsorber = model.front_shock_absorber;
            this.noisyRear = model.noisy_rear;
            this.rearShockAbsorber = model.rear_shock_absorber;
            this.electricalSystemCheck = model.electrical_system_check;
            this.alternatorCheck = model.alternator_check;
            this.battery = model.battery;
            this.fastBatteryCharge = model.fast_battery_charge;
            this.interiorLight = model.interior_light;
            this.signalLight = model.signal_light;
            this.projectorLight = model.projector_light;
            this.fluidLevelCheck = model.fluid_level_check;
            this.ACPlantControl = model.AC_plant_control;
            this.ACFilterReplacement = model.AC_filter_replacement;
            this.ACFilterSterilization = model.AC_filter_sterilization;
            this.revision = model.revision;
            this.gasPlantMaintenance = model.gas_plant_maintenance;
            this.gasCylindersRevision = model.gas_cylinders_revision;
            this.engine = model.engine;
            this.steering = model.steering;
            this.suspensions = model.suspensions;
            this.exhaustFiring = model.exhaust_firing;
            this.gearTransmission = model.gear_transmission;
            this.brakeSystem = model.brake_system;
            this.internalParts = model.internal_parts;
            this.saddlery = model.saddlery;
            this.safetyDevices = model.safety_devices;
            this.airConditioning = model.air_conditioning;
            this.wiring = model.wiring;
            this.aerialPlatformsMaintenance = model.aerial_platforms_maintenance;
            this.hydraulicSideMaintenance = model.hydraulic_side_maintenance;
            this.refrigeratedMaintenance = model.refrigerated_maintenance;
            this.craneRevision = model.crane_revision;
        }
    }
}

export class MechanicWorkingItemsRequestModel {
    coupon: boolean;
    panel_light_on: boolean;
    control_unit_software_update: boolean;
    navigator_software_update: boolean;
    braking_control: boolean;
    front_pad_replacement: boolean;
    rear_pad_replacement: boolean;
    front_disc_replacement: boolean;
    rear_disc_replacement: boolean;
    front_wipers_replacement: boolean;
    rear_wipers_replacement: boolean;
    complete_engine_distribution: boolean;
    gearbox_control: boolean;
    clutch_control: boolean;
    noisy_limber: boolean;
    front_shock_absorber: boolean;
    noisy_rear: boolean;
    rear_shock_absorber: boolean;
    electrical_system_check: boolean;
    alternator_check: boolean;
    battery: boolean;
    fast_battery_charge: boolean;
    interior_light: boolean;
    signal_light: boolean;
    projector_light: boolean;
    fluid_level_check: boolean;
    AC_plant_control: boolean;
    AC_filter_replacement: boolean;
    AC_filter_sterilization: boolean;
    revision: boolean;
    gas_plant_maintenance: boolean;
    gas_cylinders_revision: boolean;
    engine: boolean;
    steering: boolean;
    suspensions: boolean;
    exhaust_firing: boolean;
    gear_transmission: boolean;
    brake_system: boolean;
    internal_parts: boolean;
    saddlery: boolean;
    safety_devices: boolean;
    air_conditioning: boolean;
    wiring: boolean;
    aerial_platforms_maintenance: boolean;
    hydraulic_side_maintenance: boolean;
    refrigerated_maintenance: boolean;
    crane_revision: boolean;

    constructor(model?: any) {

        if (!Utilities.isVoid(model)) {
            this.coupon = model.coupon;
            this.panel_light_on = model.panelLightOn;
            this.control_unit_software_update = model.controlUnitSoftwareUpdate;
            this.navigator_software_update = model.navigatorSoftwareUpdate;
            this.braking_control = model.brakingControl;
            this.front_pad_replacement = model.frontPadReplacement;
            this.rear_pad_replacement = model.rearPadReplacement;
            this.front_disc_replacement = model.frontDiscReplacement;
            this.rear_disc_replacement = model.rearDiscReplacement;
            this.front_wipers_replacement = model.frontWipersReplacement;
            this.rear_wipers_replacement = model.rearWipersReplacement;
            this.complete_engine_distribution = model.completeEngineDistribution;
            this.gearbox_control = model.gearboxControl;
            this.clutch_control = model.clutchControl;
            this.noisy_limber = model.noisyLimber;
            this.front_shock_absorber = model.frontShockAbsorber;
            this.noisy_rear = model.noisyRear;
            this.rear_shock_absorber = model.rearShockAbsorber;
            this.electrical_system_check = model.electricalSystemCheck;
            this.alternator_check = model.alternatorCheck;
            this.battery = model.battery;
            this.fast_battery_charge = model.fastBatteryCharge;
            this.interior_light = model.interiorLight;
            this.signal_light = model.signalLight;
            this.projector_light = model.projectorLight;
            this.fluid_level_check = model.fluidLevelCheck;
            this.AC_plant_control = model.ACPlantControl;
            this.AC_filter_replacement = model.ACFilterReplacement;
            this.AC_filter_sterilization = model.ACFilterSterilization;
            this.revision = model.revision;
            this.gas_plant_maintenance = model.gasPlantMaintenance;
            this.gas_cylinders_revision = model.gasCylindersRevision;
            this.engine = model.engine;
            this.steering = model.steering;
            this.suspensions = model.suspensions;
            this.exhaust_firing = model.exhaustFiring;
            this.gear_transmission = model.gearTransmission;
            this.brake_system = model.brakeSystem;
            this.internal_parts = model.internalParts;
            this.saddlery = model.saddlery;
            this.safety_devices = model.safetyDevices;
            this.air_conditioning = model.airConditioning;
            this.wiring = model.wiring;
            this.aerial_platforms_maintenance = model.aerialPlatformsMaintenance;
            this.hydraulic_side_maintenance = model.hydraulicSideMaintenance;
            this.refrigerated_maintenance = model.refrigeratedMaintenance;
            this.crane_revision = model.craneRevision;
        }
    }
}
